<template>
  <div class="tag-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入排序码" v-model="params.sort" clearable size="small" class="param-input"></el-input>
      <el-button type="primary" size="small" icon="el-icon-search" @click="getTagConfigList('status')" style="margin-right: 20px">搜索</el-button>
      <el-button type="primary" size="small" @click="addAndEdit('add')" style="margin-right: 20px">新增</el-button>
    </div>
    <!--数据表格-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading" ref="multipleTable" height="550">
      <el-table-column prop="id" label="ID" align="center" fixed min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.id || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="collCount" label="收藏量" align="center" min-width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.collCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="fakeCollCount" label="假收藏量" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.fakeCollCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tagID" label="标签ID" align="center" min-width="210">
        <template slot-scope="scope">
          <span>{{ scope.row.tagID || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="coverImg" label="封面图" align="center" min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.coverImg === 'xxx'" style="color: #838F9B">暂无图片</span>
          <img-load 
            v-else
            style="width: 50px; height: 70px"
            :src="imgUrl + scope.row.coverImg"
            fit="fill">
          </img-load>
        </template>
      </el-table-column>
      <el-table-column prop="fakePlayCount" label="假播放量" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.fakePlayCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.sort }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="likeCount" label="点赞量" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.likeCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="playRating" label="有效播放率" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.playRating || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tPlayCount" label="总播放量(真)" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.tPlayCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tagDesc" label="标签描述" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.tagDesc || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tagName" label="标签名称" align="center" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.tagName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="vPlayCount" label="有效播放量" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.vPlayCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="videoCount" label="视频数" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.videoCount }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="修改时间" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.updatedAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center" min-width="180">
        <template slot-scope="scope">
          <span>{{ changeTime(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="180" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="success" icon="el-icon-edit" @click="addAndEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 30]" :current-page="params.pageNumber" :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total" background 
      @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!-- 新增、修改 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @before-close="handleClose">
      <el-form :model="form" label-width="80px" :rules="rules" ref="form">
        <el-form-item label="标签ID">
          <el-input v-model="form.tagID" :disabled="isDisabled"></el-input>
        </el-form-item>
        <el-form-item label="排序码" prop="sort">
          <el-input v-model.number="form.sort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="onSubmit()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 预览图片 -->
    <el-image-viewer v-if="showViewer" :on-close="() => showViewer = false" :url-list="coverList"></el-image-viewer>
  </div>
</template>

<script>
import API from '@/api';
import { validatorIndex, uniteDate } from '@/utils/validator.js';
import baseConfig from "@/utils/serverUrlConfig";

export default {
  components: { 'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer') },
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      imgUrl: baseConfig.imgUrl,
      // 封面大图预览
      coverList: [],
      showViewer: false,
      total: 0,
      params: {
        pageNumber: 1,
        pageSize: 10
      },
      form: {
        id: '',
        tagID: '',
        sort: ''
      },
      isDisabled: false,
      dialogVisible: false,
      dialogTitle: '',
      rules: {
        sort: [
          { validator: validatorIndex, trigger: 'blur'  }
        ]
      }
    };
  },
  created() {
    this.getTagConfigList();
  },
  methods: {
    // 请求列表
    getTagConfigList(type) {
      this.loading = false;
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      API.getTagConfigs(this.params)
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 新增标签配置
    addAndEdit(param) {
      this.dialogVisible = true;  // 打开新增、编辑对话框
      if(param === 'add') {
        this.dialogTitle = '新增'
      } else {
        this.dialogTitle = '编辑'
        // 把数据回显给表单
        this.form.id = param.id;
        this.form.tagID = param.tagID;
        this.form.sort = param.sort;
        this.isDisabled = true;
      }
    },
    // 新增、修改提交
    onSubmit() {
      if(this.dialogTitle === '新增') {
        this.add();
      } else {
        this.edit();
      }
    },
    // 新增方法
    add() {
      if(!this.form.tagID) {
        this.$message.warning('标签ID不能为空！！！');
        return;
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          const addData = {
            tagID: this.form.tagID,
            sort: this.form.sort
          }
          API.addTagConfig(addData)
            .then((res) => {
              if(res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.dialogVisible = false;
                this.getTagConfigList();
              } else {
                this.$message({
                  type: 'error',
                  message: '新增失败'
                })
              }
            })
            .catch(() => {
              this.getTagConfigList();
            })
        } else {
          return false;
        }
      });
    },
    // 修改方法
    edit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          API.editTagConfig(this.form)
            .then((res) => {
              if(res.code === 200) {
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                this.dialogVisible = false;
                this.getTagConfigList();
              } else {
                this.$message({
                  type: 'error',
                  message: '编辑失败'
                })
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '服务器异常'
              })
            })
        } else {
          return false;
        }
      });
    },
    // 删除方法
    del(param) {
      this.$confirm(`确认是否删除<span style='color:green'>${param.tagName}</span>, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        let delData = {
          id: param.id
        }
        API.delTagConfig(delData).then((res) => {
          if(res.code === 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          } else {
            this.$message({
              type: 'success',
              message: '删除失败!'
            });
          }
          this.getTagConfigList();
        }).catch(() => {
          this.$message({
            type: 'error',
            message: '服务器异常!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    // 关闭窗口清除数据
    handleClose() {
      this.form.tagID = undefined;
      this.form.sort = undefined;
      this.isDisabled = false;
      this.dialogVisible = false;
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getTagConfigList();
    },
    // 分页页码改变回调
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getTagConfigList();
    },
    // 更换时间格式
    changeTime(time) {
      return uniteDate(time);
    },
    // 图集预览
    getBigPicture(imgSrc) {
      this.showViewer = true;
      this.coverList = [];
      this.coverList.push(this.imgUrl + imgSrc);
    }
  },
};
</script>

<style lang="scss" scoped>
  .dialog-footer {
    position: relative;
    left: 50%;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
  }
  ::v-deep .el-image-viewer__close {
    top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 40px;
    background-color: red;
  }
</style>
